import { useTranslation } from 'react-i18next'
import { VpButton, VpLoader } from '@vtmn-play/react'
import Modal from 'components/common/mygame/modal/modal'

interface OverwriteDirectorForecastModalProps {
  open: boolean
  year: number | null
  isSaving: boolean
  onCancel: () => void
  onConfirm: () => void
}

const OverwriteDirectorForecastModal = ({
  open,
  year,
  isSaving,
  onCancel,
  onConfirm
}: OverwriteDirectorForecastModalProps) => {
  const { t } = useTranslation()

  const footer = (
    <>
      <VpButton
        data-testid="store-trajectory-edit-overwrite-cancel"
        variant="secondary"
        variantStyle="regular"
        size="medium"
        disabled={isSaving}
        onClick={onCancel}
      >
        {t('general.trajectory.store.edit.overwrite.cancel')}
      </VpButton>
      <VpButton
        data-testid="store-trajectory-edit-overwrite-confirm"
        variant="primary"
        variantStyle="regular"
        size="medium"
        disabled={isSaving}
        aria-label={isSaving ? t('general.trajectory.store.edit.overwrite.confirm') : undefined}
        onClick={onConfirm}
      >
        {isSaving ? (
          <span data-testid="store-trajectory-edit-overwrite-loader">
            <VpLoader {...({ variantStyle: 'inverse' } as any)} />
          </span>
        ) : (
          t('general.trajectory.store.edit.overwrite.confirm')
        )}
      </VpButton>
    </>
  )

  return (
    <Modal
      open={open}
      title={t('general.trajectory.store.edit.overwrite.title')}
      onClose={onCancel}
      closeOnClickOutside
      showCloseButton
      closeDisabled={isSaving}
      footer={footer}
    >
      <div className="mg-overwrite">
        <p className="vp-body-m mg-overwrite-warning">{t('general.trajectory.store.edit.overwrite.warning')}</p>
        <p className="vp-body-m">{t('general.trajectory.store.edit.overwrite.message', { year })}</p>
      </div>
    </Modal>
  )
}

export default OverwriteDirectorForecastModal
